import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getSelectedMover } from "@/store/mover/slice";

interface OnboardingGuardProps {
  children: React.ReactNode;
}

const OnboardingGuard: React.FC<OnboardingGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const mover = useSelector(getSelectedMover);

  useEffect(() => {
    // Check if onboarding is needed and user is at root path
    if (
      location.pathname === "/" &&
      mover?.mover_setup?.onboarding === true &&
      !location.pathname.includes("/get-started")
    ) {
      navigate("/get-started");
    }
  }, [mover, navigate, location.pathname]);

  return <>{children}</>;
};

export default OnboardingGuard;
